import { VpPurchaseOrder } from '../models/vp-purchase-order.model';

// WI 34963: the NCR PO typeahead searches the Viewpoint purchase orders of the user's default
// company. The API does the remote match; picking a PO pushes its vendor to the NCR vendor control.

/** The most POs one search returns. Kendo and the mobile list both show a short list. */
export const PURCHASE_ORDER_SEARCH_TOP = 25;

/** A PO as the API returns it (camelCase PurchaseOrderSearchResult DTO). */
export type VpPurchaseOrderRecord = Pick<
  VpPurchaseOrder,
  'po' | 'poCo' | 'status' | 'vendorGroup' | 'vendor'
> & {
  description?: string | null;
  orderDate?: string | null;
  vendorName?: string | null;
};

/** The record with the `name` label both platforms render: number, description, then vendor. */
export function toVpPurchaseOrder(
  record: VpPurchaseOrderRecord
): VpPurchaseOrder {
  const description = record.description ?? '';
  const vendorName = record.vendorName ?? '';
  const label = description ? `${record.po} ${description}` : record.po;
  return {
    po: record.po,
    description,
    poCo: record.poCo,
    orderDate: record.orderDate ?? null,
    status: record.status,
    vendorGroup: record.vendorGroup,
    vendor: record.vendor,
    vendorName,
    name: vendorName ? `${label} (${vendorName})` : label,
  };
}

/** Local match for the offline path, the API's rule: number starts with the term, or description contains it. */
export function purchaseOrderMatchesQuery(
  query: string,
  data: unknown
): boolean {
  const term = `${query ?? ''}`.trim().toLowerCase();
  if (!term) {
    return true;
  }
  if (!data || typeof data !== 'object') {
    return false;
  }
  const purchaseOrder = data as Partial<VpPurchaseOrder>;
  return (
    (purchaseOrder.po ?? '').toLowerCase().startsWith(term) ||
    (purchaseOrder.description ?? '').toLowerCase().includes(term)
  );
}
